import Skeleton from 'react-loading-skeleton';
import {CircleHelp, House, Menu, Sparkles, ThumbsUp} from 'lucide-react';
import {productName} from 'utils/productName.function';
import './navigationSkeleton.scss';

type Props = {
    slot?: string;
};

// Static copy of the vsn-navigation top bar, shown until /startup and the web component have loaded.
const NavigationSkeleton = ({slot}: Props) => (
    <div className="vsn-navigation-skeleton" slot={slot} aria-hidden="true" data-testid="navigation-skeleton">
        <div className="ga-page-header">
            <div className="ga-page-header__global-navigation">
                <div className="ga-page-header__menu-breadcrumbs">
                    <span className="ga-button ga-button--secondary ga-button--icon-only">
                        <span className="ga-icon"><Menu size={24}/></span>
                    </span>
                    <span className="ga-button ga-button--ghost ga-button--icon-only">
                        <span className="ga-icon"><House size={24}/></span>
                    </span>
                    <div className="ga-breadcrumb">
                        <div className="ga-breadcrumb-item ga-breadcrumb-item--link">
                            <Skeleton width={64.25}/>
                            <span className="ga-breadcrumb-item__separator">/</span>
                        </div>
                        <div className="ga-breadcrumb-item ga-breadcrumb-item--link">
                            <span className="ga-breadcrumb-item__label">{productName()}</span>
                            <span className="ga-breadcrumb-item__separator">/</span>
                        </div>
                        <div className="ga-breadcrumb-item ga-breadcrumb-item--current-page">
                            <Skeleton width={96}/>
                        </div>
                    </div>
                </div>
                <div className="ga-page-header__context-selector">
                    <Skeleton width={160} height={32}/>
                </div>
                <div className="ga-page-header__header-actions">
                    <span className="ga-button ga-button--secondary ga-button--icon-only">
                        <span className="ga-icon"><ThumbsUp size={24}/></span>
                    </span>
                    <span className="ga-button ga-button--secondary ga-button--icon-only">
                        <span className="ga-icon"><Sparkles size={24}/></span>
                    </span>
                    <span className="ga-button ga-button--secondary ga-button--icon-only">
                        <span className="ga-icon"><CircleHelp size={24}/></span>
                    </span>
                </div>
            </div>
        </div>
    </div>
);

export default NavigationSkeleton;
